import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { HINTTEXT_TYPE } from './HintTextType';

import './HintText.sass';

export const HintText = ({ children, type, style }) => {
  const getClassnameForType = useMemo(() => {
    switch (type) {
      case HINTTEXT_TYPE.INFO:
        return 'info';
      case HINTTEXT_TYPE.ERROR:
        return 'error';
      default:
        return '';
    }
  }, [type]);

  return (
    <div className="hint-text">
      <div className={`${getClassnameForType}`} style={style}>
        {children ?? null}
      </div>
    </div>
  );
};

HintText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.object]),
  type: PropTypes.oneOf(Object.values(HINTTEXT_TYPE)),
  style: PropTypes.object,
};

HintText.defaultProps = {
  type: HINTTEXT_TYPE.INFO,
  children: null,
  style: undefined,
};
